import type { Backlog, Board } from '@tasks/contracts';

import { apiRequest } from './client';

export type BoardParams = {
  /** Конкретная доска; без него сервер берёт доску по умолчанию. */
  readonly boardId?: string;
  readonly swimlane?: string;
  readonly sprintId?: string;
  readonly assigneeId?: string;
  readonly componentId?: string;
  readonly label?: string;
  readonly q?: string;
  readonly epicId?: string;
  readonly limitPerColumn?: number;
};

/** Данные доски (docs/05 §7). Все параметры вида приходят из URL. */
export function getBoard(projectKey: string, params: BoardParams = {}, signal?: AbortSignal): Promise<Board> {
  return apiRequest<Board>(`/projects/${encodeURIComponent(projectKey)}/board`, {
    query: {
      boardId: params.boardId,
      swimlane: params.swimlane,
      sprintId: params.sprintId,
      assigneeId: params.assigneeId,
      componentId: params.componentId,
      label: params.label,
      q: params.q,
      epicId: params.epicId,
      limitPerColumn: params.limitPerColumn,
    },
    signal,
  });
}

/** Бэклог + спринты + эпики. Порционно: длинные списки подгружаются частями. */
export function getBacklog(
  projectKey: string,
  params: { readonly limit?: number; readonly offset?: number } = {},
  signal?: AbortSignal,
): Promise<Backlog> {
  return apiRequest<Backlog>(`/projects/${encodeURIComponent(projectKey)}/backlog`, {
    query: { limit: params.limit, offset: params.offset },
    signal,
  });
}
